import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'mmx-text-dialog',
  templateUrl: './text-dialog.component.html',
  styleUrls: ['./text-dialog.component.scss'],
  standalone: false,
})
export class TextDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}
}
